import Vue from 'vue';
import Component from 'vue-class-component';
import { getCustomLanding } from 'services/customLanding.js';
import { Watch } from 'vue-property-decorator';

import CustomLandingCover from 'components/CustomLanding/CustomLandingCover/CustomLandingCover.vue';
import CustomLandingPlusBanner from 'components/CustomLanding/CustomLandingPlusBanner/CustomLandingPlusBanner.vue';
import CustomLandingFaqs from 'components/CustomLanding/CustomLandingFaqs/CustomLandingFaqs.vue';
import CustomLandingBoxes from 'components/CustomLanding/CustomLandingBoxes/CustomLandingBoxes.vue';
import CustomLandingActivities from 'components/CustomLanding/CustomLandingActivities/CustomLandingActivities.vue';
import updateHeaderAndFooter from 'utils/updateHeaderAndFooter';

@Component({
  components: {
    CustomLandingCover,
    CustomLandingBoxes,
    CustomLandingActivities,
    CustomLandingPlusBanner,
    CustomLandingFaqs,
  },
  metaInfo() {
    // Check if landingData is available
    if (!this.landingData) return {};

    const canonicalUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname;

    // Determine the description content and limit it to 155 characters
    let descriptionContent = [
      this.landingData.subtitle,
      this.landingData.box_section_title,
      this.landingData.activity_section_title,
    ]
      .filter(Boolean)
      .join('. ')
      .substring(0, 155);

    return {
      title: `${this.landingData.title} - Regalos Bigbox`, // Dynamically set the title
      meta: [
        {
          name: 'description',
          content: descriptionContent, // Use subtitle as description
          vmid: 'description',
        },
        {
          property: 'og:title',
          content: `${this.landingData.title} - Regalos Bigbox`, // Set OG title
          vmid: 'ogTitle',
        },
        {
          property: 'og:description',
          content: descriptionContent, // Set OG description
          vmid: 'ogDescription',
        },
        {
          property: 'og:image',
          content: this.landingData.cover_image, // Set OG image
          vmid: 'ogImage',
        },
        {
          property: 'og:url',
          content: window.location.href, // Set OG URL
          vmid: 'ogUrl',
        },
        {
          property: 'og:type',
          content: 'product',
          vmid: 'ogType',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl, // Set the canonical URL without query parameters
          vmid: 'canonical',
        },
      ],
    };
  },
})
export default class BaseCustomLandingComponent extends Vue {
  loading = false;
  landingData = null;

  landingBoxesFlag = false;
  landingActivitiesFlag = false;

  async fetchLandingData() {
    this.loading = true;
    this.landingData = await getCustomLanding(this.$route.params.landingSlug);
    if (!this.landingData) this.$router.push({ name: '404' });
    this.landingBoxesFlag = this.landingData.landing_boxes.length > 0;
    this.landingActivitiesFlag = this.landingData.landing_activities.length > 0;
    updateHeaderAndFooter(
      this.landingData.show_main_header,
      this.landingData.show_main_footer,
    );
    this.loading = false;

    // Manually trigger a re-render of the meta tags after landingData is fetched
    this.$meta().refresh();
  }

  get isLandingPlus() {
    const slug = this.$route.params.landingSlug;
    return slug === 'bigbox-plus-activos';
  }

  get isInfoLandingPlus() {
    const slug = this.$route.params.landingSlug;
    return slug === 'bigbox-plus-no-activos';
  }

  @Watch('$route.params.landingSlug', { immediate: true })
  onRouteLandingSlugChange() {
    this.fetchLandingData();
  }

  destroyed() {
    updateHeaderAndFooter();
  }
}
